import { PopupPromptComponent } from './popup-prompt.component';

export default angular
  .module('sfMobile.components.popup-prompt', [])
  .component('sfPopupPrompt', PopupPromptComponent).name;
